import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DoCheck, inject, OnInit, ViewChild } from '@angular/core';
import { KENDO_TREELIST } from '@progress/kendo-angular-treelist';
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons';
import { GridSize, KENDO_GRID, SelectableSettings } from '@progress/kendo-angular-grid';
import { KENDO_SPLITTER, LayoutModule } from '@progress/kendo-angular-layout';
import { FileInfo, KENDO_UPLOAD, SelectEvent, RemoveEvent, UploadComponent, UploadEvent, SuccessEvent, ChunkSettings } from '@progress/kendo-angular-upload';
import { DropDownListModule, DropDownsModule, KENDO_DROPDOWNLIST, KENDO_MULTICOLUMNCOMBOBOX } from '@progress/kendo-angular-dropdowns';
import { PortalObjectsService } from '../../_services/portal-objects.service';
import { PortalProjectObject } from '../../_models/project_portal_objects';
import { CommonModule } from '@angular/common';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UploadService } from '../../_services/upload.service';
import { NavigationExtras, Router } from '@angular/router';
import { plusIcon, saveIcon } from '@progress/kendo-svg-icons';
import { CanDeactivateGuard } from '../../_services/guards/confirm-deactivate.guard';
import { UploadObjectI } from '../../_models/uploads';
import { DialogRef, DialogService, DialogsModule, KENDO_DIALOGS } from '@progress/kendo-angular-dialog';
import { environment } from '../../../environments/environment';
import { UploadFile } from '../../_models/upload_files';
import { switchMap } from 'rxjs/operators';
import { LabelModule } from '@progress/kendo-angular-label';
import { KENDO_DATEINPUTS } from "@progress/kendo-angular-dateinputs";
import { KENDO_NOTIFICATION, NotificationService } from "@progress/kendo-angular-notification";
import { KENDO_INTL } from "@progress/kendo-angular-intl";
import { SubjectService } from '../../_services/subject.service';
import { formatDate } from '../../globals';

@Component({
    selector: 'app-new-upload',
    imports: [KENDO_TREELIST, KENDO_BUTTON, KENDO_GRID, KENDO_SPLITTER, KENDO_UPLOAD, KENDO_DATEINPUTS, KENDO_NOTIFICATION, KENDO_INTL,
        KENDO_MULTICOLUMNCOMBOBOX, KENDO_DIALOGS, CommonModule, DropDownListModule, DropDownsModule, InputsModule, ReactiveFormsModule, DialogsModule, FormsModule, LabelModule, LayoutModule],
    templateUrl: './new-upload.component.html',
    styleUrl: './new-upload.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class NewUploadComponent implements OnInit, DoCheck, CanDeactivateGuard {
  selectedPO!: PortalProjectObject;
  portalObjects: PortalProjectObject[] = [];
  filteredPortalObjects: PortalProjectObject[] = [];
  projects: PortalProjectObject[] = [];
  public filteredProjects: PortalProjectObject[] = [];
  selectableSettings!: SelectableSettings;
  smallSize: GridSize = 'small';
  form!: FormGroup;
  height: any;
  flag = false;
  submitClicked = false;
  uploadData!: UploadObjectI;
  orgTransmittal: string = '';
  orgRemark: string = '';
  roleDescription: string = '';
  saveButton: boolean = true;
  public icons = { plusIcon: plusIcon, saveIcon: saveIcon };
  //upload has to go directly to API to avoid 30MB max file upload
  uploadSaveUrl = `${environment.apiUrlNoProxy}/files/upload`
  uploadRemoveUrl = `${environment.apiUrl}/files/upload`
  uploadedFiles: UploadFile[] = [];
  data = [];
  files: any[] = [];
  acknowledgement = true;
  uploadInProgress = false;
  project = [{
    projectname: "Select a Project..",
    projectId: null
  }];
  selection = [];
  msg = '';
  isAdmin:boolean = false;
  newUploadButton:boolean = false;

  public chunkSettings: ChunkSettings = {
    size: 1048576 * 2, // 1024 KB * 1024 bytes = 1048576 (1 MB)
  };
  openeWindow = false;
  uploadFailed = false;
  selectionFailed = false;

  @ViewChild('uploadcomp')
  public comp!: UploadComponent;

  existingFiles = new Set<string>();
  showConfirmDialog = false;
  private confirmResolve!: (result: boolean) => void;

  selectionErrorMessage: string = '';
  selectionDialogWidth: number = 0;
  deleteEntryFlag = false;
  loading = false;

  ERROR_FILE_SELECTION_MSG = {
    COMPRESSED_FILE : 'Compressed file types are not allowed. Extract the files and upload them individually.',
    EXECUTABLE_FILE : 'Executable and scripting file types are not allowed.',
    INVALID_FILENAME_WITH_TILDE : 'The "~" or ";" character is not allowed in file names. Please rename the file and try again.'
  }

  constructor(private fb: FormBuilder, private service: UploadService, private router: Router,
    private dialog: DialogService, private cdr: ChangeDetectorRef, private portalObjectService: PortalObjectsService, private notificationService: NotificationService,
    private sub: SubjectService,private uploadService: UploadService) {
    this.form = this.fb.group({
      project: {
        projectname: "Select a Project..",
        projectId: null
      },
      purchaseOrder: {
        name: "Select an Order No..",
        id: null
      },
      uploadId: null,
      status: '',
      uploadedBy: '',
      remarks: '',
      transmittal: '',
      uploadDate: '',
      checkbox: false,
      accessType: ''
    });

    if (!this.form.value.project.projectId && !sessionStorage.getItem('projectid')) {
      this.form.get('purchaseOrder')?.disable();
    }
    const currentNavigation = this.router.getCurrentNavigation();
    if (currentNavigation?.extras.state) {
      const url = currentNavigation.extras.state['url'];
      this.data = url?.split('/');
      console.log("this.data",this.data)
      this.form.patchValue({
        project: {
          projectname: this.data[1],
          projectId: this.data[0]
        },
        purchaseOrder: {
          name: this.data[2],
          id: this.data[3]
        }
      });
    }
    if (this.data.length && this.data[4]) {
      this.form.get('project')?.disable();
      this.form.get('purchaseOrder')?.disable();

      this.flag = true;
      this.getDetails();
      this.getUploadedFiles();
    }
    if (sessionStorage.getItem('projectid')) {
      this.form.get('project')?.enable();
      this.form.get('purchaseOrder')?.enable();
    }
  }

  ngDoCheck(): void {
    this.height = document.getElementById('upload')?.clientHeight;
  }
  ngOnInit(): void {
    this.newUploadButton = false;
    const cachedUserData = sessionStorage.getItem('userData');
    if (cachedUserData) {
      let userData = JSON.parse(cachedUserData);
      this.isAdmin = userData.usertype === 'A' ? true : false;
    }
    if (this.form.value.project?.projectId) {
      this.form.get('purchaseOrder')?.enable();
      sessionStorage.setItem('projectid', JSON.stringify(this.form.value.project.projectId));
      sessionStorage.setItem('projectname', JSON.stringify(this.form.value.project.projectname));
    } if (this.form.value.purchaseOrder?.id) {
      sessionStorage.setItem('poid', JSON.stringify(this.form.value.purchaseOrder.id));
      sessionStorage.setItem('poname', JSON.stringify(this.form.value.purchaseOrder.name));
    }
    else {
      // this.form.get('purchaseOrder')?.disable();
      if (sessionStorage.getItem('projectid')) {
        let pname = JSON.parse(sessionStorage.getItem('projectname') || '');
        let pid = JSON.parse(sessionStorage.getItem('projectid') || '');
        this.form.patchValue({
          project: {
            projectname: pname,
            projectId: pid
          }
        });
      }
      if (sessionStorage.getItem('poid')) {
        //const poname: string | null = sessionStorage.getItem('poname');
        let poname = JSON.parse(sessionStorage.getItem('poname') || '');
        let poid = JSON.parse(sessionStorage.getItem('poid') || '');
        this.form.patchValue({
          purchaseOrder: {
            name: poname,
            id: poid
          }
        });
      }

      const flagValue = sessionStorage.getItem('flag');
      this.flag = flagValue ? JSON.parse(flagValue) : false;
    }
    this.portalObjectService.getProjects().subscribe({
      next: (result) => {
        this.projects = result;
        this.filteredProjects = [...this.projects];
      },
      error: (error) => {
        console.log(error)
        this.showError(JSON.stringify(error.message));
      },
      complete: () => {
        //this.isLoading = false;
      }
    });
    this.getObjectsForProjects({ projectId: this.form.value.project?.projectId, projectname: this.form.value.project?.projectname })
    if (!this.flag) {
      this.form.get('transmittal')?.disable();
      this.form.get('remarks')?.disable();
    }

    //logic to change css class of file upload message
    //class added directly to in html file since we customised it for file size
    /* const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        const fileSummaryElements = Array.from(document.querySelectorAll('.k-file-summary')) as HTMLElement[];
        fileSummaryElements.forEach((element) => {
          if (element.textContent?.includes('File failed to upload.')) {
            element.classList.add('upload-failed');
          } else if (element.textContent?.includes('File successfully uploaded.')) {
            element.classList.add('upload-success');
          }
        });
      });
    });

    const uploadContainer = document.getElementById('upload');
    if (uploadContainer) {
      observer.observe(uploadContainer, { childList: true, subtree: true });
    } */
    //end

  }
  //   getDetails() {
  //     this.service.getDetails(this.data[0], this.data[3], this.data[4]).subscribe(res => {
  //       let response = Object.values(res);
  //       this.form.patchValue({
  //         project: {
  //           projectname: this.data[1],
  //           projectId: this.data[0]
  //         },
  //         purchaseOrder: {
  //           name: this.data[2],
  //           id: this.data[3]
  //         },
  //         uploadId: response[0],
  //         status: response[10],
  //         uploadedBy: response[6],
  //         remarks: response[8],
  //         transmittal: response[9],
  //         uploadDate: response[7],
  //       });

  //       })
  //       // this.uploadData.remarks=this.form.get('remarks')?.value.remarks;
  //       // this.uploadData.transmittal=  this.form.get('transmittal')?.value.transmittal;
  // console.log('Remarks : '+this.form.get('remarks')?.value.remarks)

  //     console.log('Get Details')
  //   }

  dateValue!: Date;
  getDetails() {
    //   this.service.getDetails(this.data[0], this.data[3], this.data[4]).subscribe(result => {
    this.service.getDetails(this.data[0], this.data[3], this.data[4]).subscribe({
      next: (result: any) => {
        this.uploadData = result;
        //    this.dateValue = new Date(this.uploadData?.uploadDate.toString());
        this.form.patchValue({
          uploadId: this.uploadData?.uploadId,
          status: this.uploadData?.status ?? '',
          uploadedBy: this.uploadData?.uploadedBy ?? '',
          remarks: this.uploadData?.remarks ?? '',
          transmittal: this.uploadData?.transmittal ?? '',
          uploadDate: new Date(formatDate(this.uploadData.uploadDate)),
          accessType: this.uploadData?.accessType ?? '',
        });

      },
      error: (error) => {
        //throw message of some sort
        console.log('Error :' + JSON.stringify(error.message))
        this.showError(JSON.stringify(error.message));


      },
      complete: () => {
        this.saveButton = true;
        this.cdr.detectChanges();
        this.orgTransmittal = this.uploadData?.transmittal ?? '';
        this.orgRemark = this.uploadData?.remarks ?? '';
      }
    });
  }

  getUploadedFiles() {
    this.service.getUploadedFiles(this.data[4]).subscribe(res => {
      let response = [];
      for (let i = 0; i < res.length; i++) {
        // console.log(res[i]);
        //  let uploadDate = new Date(res[i].upload_date.toString());
        //  console.log(uploadDate)
        //   console.log(res[i].upload_date.toString())
        response.push({
          name: res[i].filename,
          size: res[i].filesize,
          file_id: res[i].file_id,
          failed: false,
          filesize_to_display: res[i].filesize_to_display,
          // upload_date: res[i].upload_date.toString()
          upload_date: res[i].upload_date

        });
      }
      this.files = response;

      this.cdr.detectChanges();
      this.uploadedFiles = res;
      for (let i = 0; i < this.uploadedFiles.length; i++) {
        //this.uploadedFiles[i].upload_date = new Date(this.uploadedFiles[i].upload_date)
        this.uploadedFiles[i].upload_date = new Date(formatDate(this.uploadedFiles[i].upload_date));
      }
      this.uploadedFiles.length ? this.acknowledgement = false : this.acknowledgement = true;
    });
  }

 onProjectSelectionChange(selectedProject: any): void {
  if (selectedProject && selectedProject.projectId) {
    this.getObjectsForProjects(selectedProject);
    this.clearObjects();
  } else {
    console.warn("Invalid project selected", selectedProject);
    this.form.get('purchaseOrder')?.disable();
    this.form.patchValue({
      purchaseOrder: {
        id: null,
        name: 'Select an Order No..'
      }
    });
  }
}

  getObjectsForProjects(event: any) {
    if (this.form.value.project?.projectId) {
      this.portalObjectService.getObjectsForProject(event?.projectId).subscribe({
        next: (result) => {
          const filtered = (result || []).filter((obj: any) => obj?.enabled === 'T');
          this.portalObjects = filtered;
          this.filteredPortalObjects = this.portalObjects;
        },
        error: (error) => {
          //throw message of some sort
          this.showError(JSON.stringify(error.message));
        },
        complete: () => {
          this.form.get('purchaseOrder')?.enable();
          //this.isLoading = false;
        }
      });
    }

  }
  clearObjects() {
    if (this.form.value.project.projectId) {
      this.form.get('purchaseOrder')?.enable();
      this.form.patchValue({
        purchaseOrder: {
          id: null,
          name: 'Select an Order No..'
        }
      });
      sessionStorage.setItem('projectid', JSON.stringify(this.form.value.project.projectId));
      sessionStorage.setItem('projectname', JSON.stringify(this.form.value.project.projectname));
      sessionStorage.removeItem('poid');
      sessionStorage.removeItem('poname');
    }
  }

  remove(e: any): void {
    e.preventDefault();
    const file = e.files[0];
    this.existingFiles.clear();
    if (file.failed) {
      const index = this.files.findIndex((f: any) => f.failed == true && f.name == file.name);
      if (index > -1) {
        this.files.splice(index, 1);
        this.files = [...this.files];
      }
    }
    else {
      const dialog: DialogRef = this.dialog.open({
        title: 'Confirm Delete',
        content: 'Are you sure you want to remove the file ?',
        actions: [{ text: 'No' }, { text: 'Yes', themeColor: 'primary' }],
        width: 450,
        height: 200,
        minWidth: 250
      });
      dialog.result.subscribe((result: any) => {
        if (result.text === 'No') {
          dialog.close();
        }
        if (result.text === 'Yes') {
          // remove file from file list in Upload Component
          if (e?.files[0].uid) {
            this.comp.fileList.remove(e?.files[0].uid);
          }
          e?.files[0].uid;

          var fileToBeRemoved: UploadFile[] = this.uploadedFiles.filter(obj => { return obj.uid == e?.files[0].uid });
          this.uploadedFiles = this.uploadedFiles.filter(obj => { return obj.uid !== e?.files[0].uid });
          let file_id = 0;
          if (this.files.length) {
            file_id = this.files.filter(obj => obj.name == e.files[0].name)[0].file_id;
            for (let i = 0; i < this.uploadedFiles.length; i++) {
              if (this.uploadedFiles[i].file_id == file_id) {
                this.uploadedFiles.splice(i, 1);
              }
            }

          }
          if (fileToBeRemoved[0]?.file_id) {
            file_id = fileToBeRemoved[0]?.file_id;
          }
          this.service.removeFiles(this.form.value.uploadId, file_id).subscribe(res => {
            this.uploadInProgress = false;
          });
          const index = this.files.findIndex((f: any) => f.failed == false && f.name == file.name);
          if (index > -1) {
            this.files.splice(index, 1);
            this.files = [...this.files];
          }
        }
      });
    }
  }

  cancel(event: any) {
    this.existingFiles.clear();
  }

  showAsActive() {
    if (this.form.get('project')?.value.projectId && this.form.get('purchaseOrder')?.value.id && !this.flag) {
      this.form.get('transmittal')?.disable();
      this.form.get('remarks')?.disable();
      this.saveButton = true;
      return true;
    }
    else {
      this.form.get('transmittal')?.enable();
      this.form.get('remarks')?.enable();
      this.saveButton = false;
      return false;
    }
  }


  convertDate(value: Date): Date {
    const dateValue = new Date(value);
    const timezoneOffset = dateValue.getTimezoneOffset(); // Offset in minutes
    const localDate = new Date(dateValue.getTime() + timezoneOffset * 60 * 1000);
    return localDate;
  }

  disableUpload():boolean{

    
    const poid: number | string | { id: number } | null =
    JSON.parse(sessionStorage.getItem('poid') ?? 'null');

    
    const matchedObject = this.filteredPortalObjects.find(obj => obj.id === poid);
    if(matchedObject && (matchedObject?.accessType == 'PROCESS' || matchedObject?.accessType == 'VIEW')){
      this.flag = true;
    }else{
      this.flag = false;
    }
    sessionStorage.setItem('flag', JSON.stringify(this.flag));
    
    console.log("variables",this.isAdmin , this.flag ,this.data.length ,
       !this.form.get('project')?.value.projectId ,!this.form.get('purchaseOrder')?.value.id,(this.flag || this.data.length > 0 || !this.form.get('project')?.value.projectId || !this.form.get('purchaseOrder')?.value.id))
    if(this.isAdmin){
      return (this.data.length > 0 || !this.form.get('project')?.value.projectId || !this.form.get('purchaseOrder')?.value.id);
    }else{
      return (this.flag || this.data.length > 0 || !this.form.get('project')?.value.projectId || !this.form.get('purchaseOrder')?.value.id);
    }
    
  }
  newUpload() {
    this.newUploadButton = true;
    this.flag = true;
    let projectid = this.form.get('project')?.value.projectId ? this.form.get('project')?.value.projectId : this.data[0];
    let objectid = this.form.get('purchaseOrder')?.value.id ? this.form.get('purchaseOrder')?.value.id : this.data[3];

    this.orgTransmittal = '';
    this.orgRemark = '';
    this.saveButton = true;
    this.service.postNewUpload(projectid, objectid).subscribe(
      {
        next: res => {
          this.uploadData = res;

          this.form.patchValue({
            uploadId: this.uploadData?.uploadId,
            status: this.uploadData?.status ?? '',
            uploadedBy: this.uploadData?.uploadedBy ?? '',
            remarks: this.uploadData?.remarks ?? '',
            transmittal: this.uploadData?.transmittal ?? '',
            uploadDate: new Date(formatDate(this.uploadData.uploadDate)),
            accessType: this.uploadData?.accessType ?? '',
            //           uploadDate: this.dateValue.toUTCString() ?? '',
            //           uploadDate: this.uploadData?.uploadDate ?? '',
          })
        },
        error: (error) => {
          console.log(error);
          this.showError(JSON.stringify(error.message));
        },
        complete: () => {
          this.form.get('project')?.disable();
          this.form.get('purchaseOrder')?.disable();
          this.form.get('transmittal')?.enable();
          this.form.get('remarks')?.enable();
        }
      }
    )
  }

  canDeactivate(): Promise<boolean> {
    if ( this.form.value.uploadId != null && (this.form.value.uploadId || this.flag) && !this.submitClicked ) {
      if(this.uploadedFiles.length==0 && this.form.value.transmittal == '' && this.form.value.remarks == ''){
        this.msg = 'Are you sure you want to leave this page? This uploaded will not be saved';
        this.deleteEntryFlag = true;
      }else{
        this.msg = 'Are you sure you want to leave this page?';
        this.deleteEntryFlag = false;
      }
      
      this.showConfirmDialog = true;
      this.cdr.detectChanges(); // Force update
      return new Promise<boolean>((resolve) => {
        this.confirmResolve = resolve;
      });
    }
    return Promise.resolve(true);
  }

  onConfirmLeave(): void {
    if(this.deleteEntryFlag){
      this.uploadService.deleteUpload(this.form.value.uploadId, this.form.get('purchaseOrder')?.value.id).subscribe({
        next: (result) => { 
          
        },
        error: (error) => {
          this.cdr.markForCheck();
          this.showError(JSON.stringify(error.message));
        },
        complete: () => {
          this.showConfirmDialog = false;
          this.sub.cancelSubject.next(false);
          this.sub.leaveSubject.next(true);
          this.confirmResolve(true);
        }
      });
      
    }else{
      let payload = {
        uploadId: this.uploadData?.uploadId,
        objectId: this.uploadData?.objectId,
        projectId: this.uploadData?.projectId,
        projectName: this.uploadData?.projectName,
        objectType: this.uploadData?.objectType,
        uploadedBy: this.uploadData?.uploadedBy,
        uploadDate: this.dateValue,
        remarks: this.uploadData?.remarks,
        transmittal: this.uploadData?.transmittal,
        status: this.uploadData?.status
      }

      this.service.updateUpload(this.form.get('project')?.value.projectId, this.form.get('purchaseOrder')?.value.id, payload).subscribe({
        next: (result) => {
          this.uploadData = result;
          this.form.patchValue({
            uploadId: this.uploadData?.uploadId,
            status: this.uploadData?.status ?? '',
            uploadedBy: this.uploadData?.uploadedBy ?? '',
            remarks: this.uploadData?.remarks ?? '',
            transmittal: this.uploadData?.transmittal ?? '',
            uploadDate: this.uploadData?.uploadDate ?? '',
            accessType: this.uploadData?.accessType ?? '',
          });

        },
        error: (error) => {
          //throw message of some sort
          this.showError(JSON.stringify(error.message));

        },
        complete: () => {
          this.showConfirmDialog = false;
          this.sub.cancelSubject.next(false);
          this.sub.leaveSubject.next(true);
          this.confirmResolve(true);
          //this.saveButton = true;
          //this.cdr.detectChanges();
          //this.orgTransmittal = this.uploadData?.transmittal ?? '';
          //this.orgRemark = this.uploadData?.remarks ?? '';
        }
      });

      
    }
    
  }

  onCancelLeave(): void {
    this.showConfirmDialog = false;
    this.sub.leaveSubject.next(false);
    this.sub.cancelSubject.next(true);
    this.confirmResolve(false);
  }



  submit() {
    this.submitClicked = true;
    this.loading = true;
    let todayDate = new Date().toISOString().slice(0, 10);
    let payload = {
      uploadId: this.uploadData?.uploadId ?? this.data[4],
      objectId: this.uploadData?.objectId ?? this.data[3],
      projectId: this.uploadData?.projectId ?? this.data[0],
      projectName: this.uploadData?.projectName ?? this.data[1],
      objectType: this.uploadData?.objectType ?? this.data[2],
      uploadedBy: this.uploadData?.uploadedBy ?? this.form.value.uploaded_by,
      //   uploadDate: this.uploadData?.uploadDate ?? this.form.value.upload_date,
      uploadDate: todayDate,

      remarks: this.uploadData?.remarks ?? this.form.value.remarks,
      transmittal: this.uploadData?.transmittal ?? this.form.value.transmittal,
      // status: this.uploadData?.status ?? this.form.value.status
      status: 'Pending Acknowledgement'
    }
    this.service.updateUpload(this.form.get('project')?.value.projectId, this.form.get('purchaseOrder')?.value.id, payload).pipe(
      switchMap((res: UploadObjectI) => {
        this.uploadData = res;
        // console.log('submit '+this.uploadData )
        //         this.form.patchValue({
        //           uploadId: this.uploadData?.uploadId,
        //           status: this.uploadData?.status ?? '',
        //           uploadedBy: this.uploadData?.uploadedBy ?? '',
        //           remarks: this.uploadData?.remarks ?? '',
        //           transmittal: this.uploadData?.transmittal ?? '',
        //           uploadDate: this.uploadData?.uploadDate ?? '',
        // //          uploadDate: todayDate,
        //         });

        // Return the observable from sendMails
        return this.service.sendMails(this.uploadData);
      })
    )
      .subscribe(
        {
          next: res => {
            console.log("Email send response:", res);
          },
          error: (e) => {

            this.showError(e.message);

          },
          complete: () => {
            this.loading= false;
            const navigationExtras: NavigationExtras = {
              state: {
                url: `${this.form.get('project')?.value.projectId}/${this.form.get('purchaseOrder')?.value.id}/${this.form.get('project')?.value.projectname}/${this.form.get('purchaseOrder')?.value.name}/pending-acknowledgement`
              }
            };
            this.router.navigate(['/submittals'], navigationExtras);
          }
        }
      )
  }


  uploadEventHandler(e: UploadEvent): void {
    this.acknowledgement = true;
    this.uploadInProgress = true;
    let todayDate = new Date().toISOString().slice(0, 10);
    e.data = {
      fileExtension: e.files[0].extension,
      projectId: this.uploadData?.projectId ?? this.data[0],
      uploadId: this.uploadData?.uploadId ?? this.data[4],
      poId: this.uploadData?.objectId ?? this.data[3],
      fileId: 0,
      filename: e.files[0].name,
      filesize: e.files[0].size,
      //      uploadDate: this.form.value.uploadDate,
      uploadDate: todayDate,
      remarks: this.form.value.remarks,
      uploadedBy: ''
    }
    this.acknowledgement = false;
  }

  onSelect(event: SelectEvent): void {
    const maxFileSize = 2 * 1024 * 1024 * 1024; // 2 GB in bytes
    const compressedFileExtensions = [
      //Compressed File Types
      '.zip', '.rar', '.7z', '.tar', '.tar.gz', '.tar.bz2', 'gz', '.bz2', '.xz', '.lz', '.lzma', '.cab', '.iso'];
    
    const executableFileExtensions = [
      //Executable and Scripting File Types
      '.exe', '.bat', '.cmd', '.msi', '.dll', '.sh', '.bin', '.ps1', '.vbs', '.py', '.js', '.php', '.ts', '.rb', '.pl'
    ];
    let fileList: FileInfo[] = []
    for (const file of event.files) {
      const key = `${file.name}-${file.size}`;
      if (!this.existingFiles.has(key)) {
        this.existingFiles.add(key);
        fileList.push(file);
      }
    }

    if (fileList.length === 0) {
      event.preventDefault();
      return;
    }

    const normalizeName = (name: string) => name.replace(/\uFF5E/g, '~');
    
    fileList.forEach((file) => {
      const fileName = normalizeName(file.name);
      const extension = file.name.slice(file.name.lastIndexOf('.')).toLowerCase();

      if (/[~;]/.test(fileName)) {
        event.preventDefault();
        this.selectionErrorMessage =
          this.ERROR_FILE_SELECTION_MSG?.INVALID_FILENAME_WITH_TILDE
          ?? 'File name cannot contain "~" or ";". Please rename the file and try again.';
        this.selectionDialogWidth = 500;
        this.selectionFailed = true;
        return; // stop further checks on this file
      }

      if (compressedFileExtensions.includes(extension)) {
        event.preventDefault();
        this.selectionErrorMessage = this.ERROR_FILE_SELECTION_MSG.COMPRESSED_FILE;
        this.selectionDialogWidth = 600;
        if (!this.selectionFailed) {
          this.selectionFailed = true;
        }

      }
      else if(executableFileExtensions.includes(extension)) {
        event.preventDefault();
        this.selectionErrorMessage = this.ERROR_FILE_SELECTION_MSG.EXECUTABLE_FILE;
        this.selectionDialogWidth = 500;
        if (!this.selectionFailed) {
          this.selectionFailed = true;
        }

      }
      if (file.rawFile && file.rawFile.size > maxFileSize) {
        // File size exceeds 2 GB
        event.preventDefault(); // Prevent the upload
        // Show an error message
        const fileName = file.name;
        alert(`Error: The file "${fileName}" exceeds the maximum limit of 2 GB.`);
        // Replace this with your preferred method of displaying error messages
      }
    });
  
  }

  successfulUpload(event: SuccessEvent) {
    this.acknowledgement = true;
    var file: UploadFile = {
      file_id: event.response.body.file_id,
      filename: event.response.body.filename,
      file_extension: event.response.body,
      filesize: event.response.body.filesize,
      upload_date: event.response.body.upload_date,
      uploaded_by: event.response.body.uploaded_by,
      remarks: event.response.body.remarks,
      acknowledged: event.response.body.acknowledged,
      processed: event.response.body.processed,
      status: event.response.body.status,
      validated: '',
      uid: event.files[0].uid ?? '',
      filesize_to_display: event.response.body.filesize_to_display,
      rejected: event.response.body.rejected,
      rejectedRemarks: event.response.body.rejectedRemarks,
    }
    //file.upload_date = new Date(event.response.body.upload_date);
    file.upload_date = new Date(formatDate(event.response.body.upload_date));
    event.files.forEach((file: any) => {
      file.failed = false;
      this.files.push(file);
    });
    this.uploadedFiles.push(file);
    this.acknowledgement = false;
    this.uploadInProgress = false;
    this.existingFiles.clear();
  }
  updatePO() {
    this.form.value.purchaseOrder.name = 'Select an Order No..';
    this.form.value.purchaseOrder.id = null;
  }
  closeAccessWindow() {
    this.openeWindow = false;
  }

  selectionChange(event: any) {
    // const i = this.portalObjects.findIndex((x) => x.id == event.id);
    if (event.id) {
      sessionStorage.setItem('poid', JSON.stringify(event.id));
      sessionStorage.setItem('poname', JSON.stringify(event.name));
    }
    this.flag = true; 
    sessionStorage.setItem('flag', JSON.stringify(this.flag));
    if (event.accessType === 'UPLOAD' || event.accessType === 'ADMIN') {
      this.flag = false;
      sessionStorage.setItem('flag', JSON.stringify(this.flag));
    }
    if (event.accessType === 'VIEW') {
      this.roleDescription = 'View Role';
    }
    if (event.accessType === 'UPLOAD') {
      this.roleDescription = 'Upload Role';
    }
    if (event.accessType === 'PROCESS') {
      this.roleDescription = 'Process Role';
    }
    if (event.accessType === 'ADMIN') {
      this.roleDescription = 'Full Admin';
    }
  }

  saveUpload() {
    let payload = {
      uploadId: this.uploadData?.uploadId,
      objectId: this.uploadData?.objectId,
      projectId: this.uploadData?.projectId,
      projectName: this.uploadData?.projectName,
      objectType: this.uploadData?.objectType,
      uploadedBy: this.uploadData?.uploadedBy,
      uploadDate: this.dateValue,
      remarks: this.uploadData?.remarks,
      transmittal: this.uploadData?.transmittal,
      status: this.uploadData?.status
    }

    this.service.updateUpload(this.form.get('project')?.value.projectId, this.form.get('purchaseOrder')?.value.id, payload).subscribe({
      next: (result) => {
        this.uploadData = result;
        this.form.patchValue({
          uploadId: this.uploadData?.uploadId,
          status: this.uploadData?.status ?? '',
          uploadedBy: this.uploadData?.uploadedBy ?? '',
          remarks: this.uploadData?.remarks ?? '',
          transmittal: this.uploadData?.transmittal ?? '',
          uploadDate: this.uploadData?.uploadDate ?? '',
          accessType: this.uploadData?.accessType ?? '',
        });

      },
      error: (error) => {
        //throw message of some sort
        this.showError(JSON.stringify(error.message));

      },
      complete: () => {
        this.saveButton = true;
        this.cdr.detectChanges();
        this.orgTransmittal = this.uploadData?.transmittal ?? '';
        this.orgRemark = this.uploadData?.remarks ?? '';
      }
    });


  }
  onChange(value: string, type: string) {
    this.saveButton = true;

    if (type === 'transmittal') {
      this.uploadData.transmittal = value;
    }
    if (type === 'remark') {
      this.uploadData.remarks = value;
    }
    let transmittal = '';
    let remark = '';
    if (this.uploadData.transmittal !== null) {
      transmittal = this.uploadData.transmittal;
    }
    if (this.uploadData.remarks !== null) {
      remark = this.uploadData.remarks;
    }
    if (transmittal !== this.orgTransmittal || remark !== this.orgRemark) {
      this.saveButton = false;
    }
    else {
      this.saveButton = true;
    }
    this.cdr.detectChanges();
  }

  public showError(value: string): void {
    this.notificationService.show({
      content: value,

      hideAfter: 10000,
      position: { horizontal: "right", vertical: "top" },
      animation: { type: "slide", duration: 400 },
      type: { style: "error", icon: true },
    });
  }

  onUploadError(event: any) {
    let response = event.response?.error;
    if (response.error === 'DUPLICATE_FILE') {
      this.uploadFailed = true;
      this.uploadInProgress = false;
    }

    event.files.forEach((file: any) => {
      file.failed = true;
      this.files.push(file);
    });
    this.uploadInProgress = false;
  }

  checkboxCondition() {
    let hasFiles = this.uploadedFiles.length ? true : false;
    let uploadedCheck = this.files.every((file: any) => file.failed == false);
    return !(hasFiles && !this.uploadInProgress && uploadedCheck);
  }

  closeDialog() {
    this.uploadFailed = false;
    this.existingFiles.clear();
  }

  uploadCondition() {
    console.log("this.newUploadButton",this.newUploadButton,"this.uploadData",this.uploadData,"this.isAdmin",this.isAdmin)
   // alert(!this.newUploadButton|| !( (this.uploadData && this.uploadData.uploadId && this.uploadData.accessType === 'UPLOAD') || !this.isAdmin ));
    
    if(this.isAdmin){
      return !(this.newUploadButton|| (this.uploadData && this.uploadData.uploadId && this.isAdmin));
    }else{
      return !this.newUploadButton|| !( (this.uploadData && this.uploadData.uploadId && this.uploadData.accessType === 'UPLOAD'));
    }
    
  }

  closeSelectionDialog() {
    this.selectionFailed = false;
    this.existingFiles.clear();
  }

  formatFileSize(bytes: number): string {
    let kb = bytes / 1024.0;
    let mb = kb / 1024.0;
    let gb = mb / 1024.0;

    if(mb < 1){
        return `${kb.toFixed(2)} KB`;
    }
    else if(gb < 1){
        return `${mb.toFixed(2)} MB`;
    }
    else{
        return `${gb.toFixed(2)} GB`;
    }
  }

  

onProjectFilter(value: string): void {
  console.log("this.filteredProjects",this.filteredProjects,value)
  this.filteredProjects = this.projects.filter(p =>
    p.projectname && p.projectname.toLowerCase().includes(value.toLowerCase())
  );

   console.log("this.filteredProjects--->",this.filteredProjects)
}

onOrderFilter(value: string): void {
  this.filteredPortalObjects = this.portalObjects.filter(p =>
    p.name && p.name.toLowerCase().includes(value.toLowerCase())
  );
}


}
